<template>
	<base-dialog :value="value"
			@input="updateValue"
			@success="pushRemove"
			button-success-color="error"
			:button-success-text="$t('remove')"
			button-fail-color="outline"
			:button-fail-text="$t('cancel')"
			:title="$t('confirm-delete.title')">
		<p class="confirm-text">
			{{ body }}
		</p>
	</base-dialog>
</template>

<script>
	import BaseDialog from './dialog';

	export default {
		components: { BaseDialog },
		props: {
			value: Boolean,
			body: String,
		},
		methods: {
			updateValue(value) {
				this.$emit('input', value);
			},
			pushRemove() {
				this.$emit('remove');
				this.updateValue(false);
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "@/styles/colors.scss";

	.confirm-text {
		margin: 5px 28px;
		color: $light-blue;
		font-weight: normal;
		text-align: center;
		font-size: 16px;
	}
</style>
